import { Col, Flex, message, Row, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './SummaryDevicePage.scss';
import CardComponent from '../../../components/device/SummaryComponents/CardComponent/CardComponent';
import { DataTelemetryData } from '../../../models/telemetry';
import ReleComponent from '../../../components/device/SummaryComponents/ReleComponent/ReleComponent';
import useTelemetryStore from '../../../stores/telemetry.store';
import CommandComponent from '../../../components/device/SummaryComponents/CommandComponent/CommandComponent';
import { Device } from '../../../gen/proto/api/gateway/v1/gateway_pb';
import useDeviceStore from '../../../stores/device.store';

const INTERVAL_REFRESH_MS = 2000;
const NO_DATA = 'No hay datos';

const SummaryDevicePage = () => {
  const { deviceUuid } = useParams() as { deviceUuid: string };
  const [messageApi, contextHolder] = message.useMessage();

  const getDeviceByUuid = useDeviceStore((state) => state.getByUuid);
  const [device, setDevice] = useState<Device | null>(null);

  const [deviceData, setDeviceData] = useState<DataTelemetryData | null>(null);

  const getActualTelemetryData = useTelemetryStore((state) => state.getActualTelemetryData);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const device = await getDeviceByUuid(deviceUuid);
        setDevice(device);
        const deviceData = await getActualTelemetryData(deviceUuid);
        setDeviceData(deviceData);
      } catch (error) {
        messageApi.error((error as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [deviceUuid, getDeviceByUuid, getActualTelemetryData, messageApi]);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const deviceData = await getActualTelemetryData(deviceUuid);
        setDeviceData(deviceData);
      } catch (error) {
        messageApi.error((error as Error).message);
      }
    }, INTERVAL_REFRESH_MS);
    return () => clearInterval(interval);
  }, [deviceUuid, getActualTelemetryData, messageApi]);

  const DEVICE_GROUP_MAP: Record<string, number> = {
    'iFoam Compact': 1,
    'iFoam Pro': 1,
    Proair: 2,
    Multipro: 2,
    Rotair: 2,
    Eon: 2,
    Protub: 3,
    iBrush: 3,
    Multibot: 4,
    Visiobot: 5,
  };

  const deviceType = device?.data?.type;
  const deviceGroup = typeof deviceType === 'string' ? (DEVICE_GROUP_MAP[deviceType] ?? -1) : -1;

  return (
    <Flex vertical>
      {contextHolder}
      <Spin spinning={loading} size={'large'} fullscreen={true} style={{ zIndex: 999 }} />
      <Row>
        <Col span={12} className={'SummaryDevicePage__col1'}>
          <CardComponent title={'Alerta actual'} value={deviceData?.alert ?? NO_DATA} />
          {deviceGroup === 1 && (
            <CardComponent
              title={deviceData?.sensors && deviceData.sensors.length > 0 ? deviceData.sensors[0].type : 'Presión'}
              value={
                deviceData?.sensors && deviceData.sensors.length > 0
                  ? deviceData.sensors[0].value + ' ' + deviceData.sensors[0].unit
                  : 'No hay datos'
              }
            />
          )}
          {deviceGroup === 2 && (
            <>
              <CardComponent title={'Usuario actual'} value={deviceData?.user_id ?? NO_DATA} />
              <CardComponent title={'Dirección 2'} value={deviceData?.command?.command_direction_2 ?? NO_DATA} />
            </>
          )}
          {deviceGroup === 3 && (
            <>
              <CardComponent title={'Dirección 1'} value={deviceData?.command?.command_direction_1 ?? NO_DATA} />
              <ReleComponent reles={deviceData?.reles ?? []} />
            </>
          )}
          {deviceGroup === 4 && (
            <>
              <CommandComponent title={'1'} speed={deviceData?.command.command_speed_1.value ?? 0} />
              <CardComponent title={'Dirección 1'} value={deviceData?.command?.command_direction_1 ?? NO_DATA} />
            </>
          )}
          {deviceGroup === 5 && <CommandComponent title={'1'} speed={deviceData?.command.command_speed_1.value ?? 0} />}
        </Col>
        <Col span={12} className={'SummaryDevicePage__col2'}>
          <CardComponent title={'Comando activo'} value={deviceData?.command.type ?? NO_DATA} />
          {deviceGroup === 1 && <ReleComponent reles={deviceData?.reles ?? []} />}
          {deviceGroup === 2 && (
            <>
              <CardComponent title={'Dirección 1'} value={deviceData?.command?.command_direction_1 ?? NO_DATA} />
              <ReleComponent reles={deviceData?.reles ?? []} />
            </>
          )}
          {deviceGroup === 3 && (
            <CardComponent title={'Dirección 2'} value={deviceData?.command?.command_direction_2 ?? NO_DATA} />
          )}
          {deviceGroup === 4 && (
            <>
              <CommandComponent title={'2'} speed={deviceData?.command.command_speed_2.value ?? 0} />
              <CardComponent title={'Dirección 2'} value={deviceData?.command?.command_direction_2 ?? NO_DATA} />
            </>
          )}
          {deviceGroup === 5 && <CommandComponent title={'2'} speed={deviceData?.command.command_speed_2.value ?? 0} />}
        </Col>
      </Row>
    </Flex>
  );
};

export default SummaryDevicePage;
